import {
    PromotedServiceAssignmentAddParameters,
    PromotedServiceAssignmentResult,
    useRepositoryMutation,
} from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { MewsTeam } from '@mews/enums';
import { FormValues, servicePromotionSchema } from '../schema';
import { getOptionsFromFormValues } from '../utils/queryUtils';

interface MutationProps {
    serviceId: string;
    onSuccess: (data: PromotedServiceAssignmentResult) => void;
}

export const toServicePromotionAddParams =
    ({ serviceId }: { serviceId: string }) =>
    (formValues: FormValues): PromotedServiceAssignmentAddParameters => ({
        serviceId,
        ...formValues,
        options: getOptionsFromFormValues(formValues.promotedServiceAssignmentOptions),
    });

export const useAddServicePromotionMutation = ({ serviceId, onSuccess }: MutationProps) =>
    useRepositoryMutation('promotedServiceAssignments', 'add', {
        transformParams: (formValues: FormValues) =>
            servicePromotionSchema.transform(toServicePromotionAddParams({ serviceId })).parse(formValues),
        invalidateQueries: {
            promotedServiceAssignments: ['getAll'],
        },
        onSuccess: (data) => {
            showSuccessAlert({
                description: lt(TextKey.PromotedServiceAssignmentAddSuccessMessage),
                action: { text: lt(TextKey.ViewDetails), onClick: () => onSuccess(data) },
                id: data.promotedServiceAssignments[0].id,
            });
        },
        meta: {
            logError: {
                team: MewsTeam.Spacetime,
            },
        },
    });
